import { ArnCondition, ArnPredefinedConditionTemplate } from './ArnCondition';
import { ArnConditionOpts } from './ArnConditionOpts';

export type ArnHttpConditionRequest = {
  url: string;
  method: string;
  body?: BodyInit;
  headers?: HeadersInit;
};

export type ArnHttpConditionResponse = {
  status: number;
  text?: string;
  jsonPath?: {
    path: string;
    value: any;
  };
};

export interface MatchHttpResponseConditionOpts extends ArnConditionOpts {
  request: ArnHttpConditionRequest;
  response: ArnHttpConditionResponse;
}

export class MatchHttpResponseCondition implements ArnCondition {
  readonly templateName = ArnPredefinedConditionTemplate.MatchHttpResponse;

  constructor(public opts: MatchHttpResponseConditionOpts) {}
}
